import type { Resource } from 'i18next'
import daDK from './da-DK/common.json'
import deDE from './de-DE/common.json'
import enGB from './en-GB/common.json'
import esES from './es-ES/common.json'
import etEE from './et-EE/common.json'
import fiFI from './fi-FI/common.json'
import frFR from './fr-FR/common.json'
import ltLT from './lt-LT/common.json'
import lvLV from './lv-LV/common.json'
import nbNO from './nb-NO/common.json'
import nlNL from './nl-NL/common.json'
import plPL from './pl-PL/common.json'
import ruRU from './ru-RU/common.json'
import svSE from './sv-SE/common.json'

export const SUPPORTED_LANGUAGES = [
	'en-GB',
	'da-DK',
	'de-DE',
	'et-EE',
	'es-ES',
	'fr-FR',
	'lv-LV',
	'lt-LT',
	'nl-NL',
	'nb-NO',
	'pl-PL',
	'ru-RU',
	'fi-FI',
	'sv-SE',
] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en-GB'

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
	'en-GB': 'English',
	'da-DK': 'Dansk',
	'de-DE': 'Deutsch',
	'et-EE': 'Eesti',
	'es-ES': 'Español',
	'fr-FR': 'Français',
	'lv-LV': 'Latviešu',
	'lt-LT': 'Lietuvių',
	'nl-NL': 'Nederlands',
	'nb-NO': 'Norsk',
	'pl-PL': 'Polski',
	'ru-RU': 'Русский',
	'fi-FI': 'Suomi',
	'sv-SE': 'Svenska',
}

export const resources: Resource = {
	'en-GB': { common: enGB },
	'da-DK': { common: daDK },
	'de-DE': { common: deDE },
	'et-EE': { common: etEE },
	'es-ES': { common: esES },
	'fr-FR': { common: frFR },
	'lv-LV': { common: lvLV },
	'lt-LT': { common: ltLT },
	'nl-NL': { common: nlNL },
	'nb-NO': { common: nbNO },
	'pl-PL': { common: plPL },
	'ru-RU': { common: ruRU },
	'fi-FI': { common: fiFI },
	'sv-SE': { common: svSE },
}

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
	return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value)
}
